module.exports = __webpack_public_path__ + "img/icon-sun.b3182f3b.svg";